// extracted by mini-css-extract-plugin
export default {"topLogo":"index_topLogo_F1U0p","bodybg":"index_bodybg_wM0AV","footer":"index_footer_sLkf4"};